var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoSearchNotFound = function SvgIcoSearchNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 105,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    y: 0.5,
    rx: 52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m64.062 61.734 8.565 8.565-2.828 2.828-8.565-8.565A17.92 17.92 0 0 1 50 68.5c-9.936 0-18-8.064-18-18s8.064-18 18-18 18 8.064 18 18c0 4.248-1.474 8.154-3.938 11.234m-4.013-1.484A13.95 13.95 0 0 0 64 50.5c0-7.735-6.265-14-14-14s-14 6.265-14 14 6.265 14 14 14c3.791 0 7.23-1.505 9.75-3.95z"
  })));
};
export default SvgIcoSearchNotFound;